webpackJsonp([5],{

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_picker_pug__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_picker_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__date_picker_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_consts__ = __webpack_require__(32);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var MODULE_NAME = 'datePicker';
var MONTHS = [{ month: 'Január', value: '1' }, { month: 'Február', value: '2' }, { month: 'Március', value: '3' }, { month: 'Április', value: '4' }, { month: 'Május', value: '5' }, { month: 'Június', value: '6' }, { month: 'Július', value: '7' }, { month: 'Augusztus', value: '8' }, { month: 'Szeptember', value: '9' }, { month: 'Október', value: '10' }, { month: 'November', value: '11' }, { month: 'December', value: '12' }];

var DATE_FORMAT = 'YYYY-MM-DD';

var DatePickerController = function () {
	DatePickerController.$inject = ['$scope', '$element', '$timeout'];

	function DatePickerController($scope, $element, $timeout) {
		'ngInject';

		_classCallCheck(this, DatePickerController);

		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$element = $element[0];
		this.initWatchers();
	}

	DatePickerController.prototype.$onInit = function $onInit() {
		this.selectedYear = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateModel).year() + '';
		this.days = this.updateDaysList(this.dateModel);
		this.selectedDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateModel).date() + '';
		this.minimumDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.minDate, __WEBPACK_IMPORTED_MODULE_2__constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]);
		this.maximumDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.maxDate, __WEBPACK_IMPORTED_MODULE_2__constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]);
		this.updateYears();
		this.updateMonthList();
		this.selectedMonth = this.months[__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateModel).month()];
	};

	DatePickerController.prototype.$onChanges = function $onChanges(changeObject) {
		if (changeObject.dateModel && !changeObject.dateModel.isFirstChange()) {
			var dateModel = angular.copy(this.dateModel);
			this.selectedYear = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateModel).year() + '';
			this.selectedMonth = this.months[__WEBPACK_IMPORTED_MODULE_1_moment___default()(dateModel).month()];
			this.selectedDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateModel).date() + '';
		}
	};

	DatePickerController.prototype.initWatchers = function initWatchers() {
		var _this = this;

		this.$scope.$watch('$ctrl.selectedYear', function (newValue) {
			if (newValue) {
				_this.dateModel = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.dateModel).year(newValue);
				_this.updateDaysList(angular.copy(_this.dateModel));
				_this.onDateChange({ date: _this.dateModel });
			}
		});
		this.$scope.$watch('$ctrl.selectedMonth', function (newValue) {
			if (newValue) {
				_this.dateModel = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.dateModel).month(newValue.value - 1);
				_this.updateDaysList(angular.copy(_this.dateModel));
				_this.dateModel = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.dateModel).date(_this.dateModel.date());
				_this.onDateChange({ date: _this.dateModel });
			}
		});
		this.$scope.$watch('$ctrl.selectedDay', function (newValue) {
			if (newValue) {
				_this.dateModel = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.dateModel).date(newValue);
				_this.onDateChange({ date: _this.dateModel });
			}
		});
	};

	DatePickerController.prototype.getLastDayOfMonth = function getLastDayOfMonth(date) {
		return new Date(__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).year(), __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).month() + 1, 0, 23, 59, 59).getDate();
	};

	DatePickerController.prototype.updateMonthList = function updateMonthList() {
		this.months = MONTHS;
	};

	DatePickerController.prototype.updateDaysList = function updateDaysList(date) {
		var _this2 = this;

		this.days = [];
		for (var i = 1; i <= this.getLastDayOfMonth(date); ++i) {
			this.days.push('' + i);
		}
		this.$timeout(function () {
			if (_this2.$element.querySelector('select[name="nap"]+.accessible-select-wrapper')) {
				_this2.$element.querySelector('select[name="nap"]').nativeAccessibleSelect.render();
			}
		});
		this.selectedDay = '1';
	};

	DatePickerController.prototype.updateYears = function updateYears() {
		var result = [];
		var min = this.minimumDate.isValid() ? this.minimumDate.year() : 1900;
		var max = this.maximumDate.isValid() ? this.maximumDate.year() : 2100;
		for (var i = min; i <= max; ++i) {
			result.push('' + i);
		}
		this.years = result;
	};

	return DatePickerController;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).component('datePicker', {
	controller: DatePickerController,
	template: __WEBPACK_IMPORTED_MODULE_0__date_picker_pug___default()(),
	bindings: {
		id: '@',
		dateModel: '<',
		minDate: '<',
		maxDate: '<',
		onDateChange: '&',
		mainLabel: '@'
	}
}).name);

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"sr-only\" aria-hidden=\"true\" ng-attr-id=\"{{$ctrl.id + '-year-label'}}\" ng-attr-for=\"{{$ctrl.id + '-year'}}\"\u003E{{$ctrl.mainLabel}} Év\u003C\u002Flabel\u003E\u003Cselect class=\"select\" ng-attr-id=\"{{$ctrl.id + '-year'}}\" name=\"ev\" ng-options=\"item for item in $ctrl.years track by item\" ng-model=\"$ctrl.selectedYear\" aria-labelledby=\"{{$ctrl.mainLabel}} {{$ctrl.id + '-year-label'}}\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Clabel class=\"sr-only\" aria-hidden=\"true\" ng-attr-id=\"{{$ctrl.id + '-month-label'}}\" ng-attr-for=\"{{$ctrl.id + '-month'}}\"\u003E{{$ctrl.mainLabel}} Hónap\u003C\u002Flabel\u003E\u003Cselect class=\"select\" ng-attr-id=\"{{$ctrl.id + '-month'}}\" name=\"honap\" ng-options=\"item.month for item in $ctrl.months track by item.month\" ng-model=\"$ctrl.selectedMonth\" aria-labelledby=\"{{$ctrl.mainLabel}} {{$ctrl.id + '-month-label'}}\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3\"\u003E\u003Clabel class=\"sr-only\" aria-hidden=\"true\" ng-attr-id=\"{{$ctrl.id + '-day-label'}}\" ng-attr-for=\"{{$ctrl.id + '-day'}}\"\u003E{{$ctrl.mainLabel}} Nap\u003C\u002Flabel\u003E\u003Cselect class=\"select\" ng-attr-id=\"{{$ctrl.id + '-day'}}\" name=\"nap\" ng-options=\"item for item in $ctrl.days track by item\" ng-model=\"$ctrl.selectedDay\" aria-labelledby=\"{{$ctrl.mainLabel}} {{$ctrl.id + '-day-label'}}\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_container_pug__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_container_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__grafikon_container_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grafikon_form_grafikon_form__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grafikon_megjelenito_grafikon_megjelenito__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_arfolyam_service__ = __webpack_require__(48);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Grafikon komponens
 * @author Koppany Kiss 2017.05.22.
 */





var MODULE_NAME = 'grafikonContainer';

var GrafikonContainerController = function () {
	GrafikonContainerController.$inject = ['arfolyamService', '$rootScope'];

	function GrafikonContainerController(arfolyamService, $rootScope) {
		'ngInject';

		_classCallCheck(this, GrafikonContainerController);

		this.arfolyamService = arfolyamService;
		this.rootScope = $rootScope;
		this.showLoader = false;
		this.showGrafikon = false;
		this.notEnoughData = false;
	}

	GrafikonContainerController.prototype.$onInit = function $onInit() {
		var _this = this;

		this.arfolyamService.getGrafikonInitDates().then(function (response) {
			_this.initData = response.data;
		}, function (error) {
			_this.error = error;
			_this.rootScope.$broadcast('serverError');
		});
	};

	GrafikonContainerController.prototype.getGrafikon = function getGrafikon(requestModel) {
		var _this2 = this;

		this.notEnoughData = false;
		this.showGrafikon = false;
		this.showLoader = true;

		this.arfolyamService.getArfolyam(requestModel).then(function (response) {
			_this2.showLoader = false;
			_this2.chartOptions = _this2.arfolyamService.getPortfolioChartAdatok(response.data);

			if (!_this2.chartOptions) {
				_this2.notEnoughData = true;
			} else {
				_this2.showGrafikon = true;
			}
		}, function (error) {
			_this2.showLoader = false;
			_this2.rootScope.$broadcast('serverError');
			_this2.error = error;
		});
	};

	return GrafikonContainerController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_3__services_arfolyam_service__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__grafikon_form_grafikon_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__grafikon_megjelenito_grafikon_megjelenito__["a" /* default */]]).component('grafikonContainer', {
	controller: GrafikonContainerController,
	template: __WEBPACK_IMPORTED_MODULE_0__grafikon_container_pug___default()(),
	bindings: {}
}).name);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * arfolyam service az árfolyamok lekérdezéshez tartozó servie
 * @author István Rózsa 2017.05.16.
 */

var MODULE_NAME = 'arfolyamService';

var ArfolyamService = function () {
	ArfolyamService.$inject = ['$http'];

	function ArfolyamService($http) {
		'ngInject';

		_classCallCheck(this, ArfolyamService);

		this.$http = $http;
		this.apiRoot = '/api';
	}

	ArfolyamService.prototype.getAktualisArfolyamok = function getAktualisArfolyamok() {
		return this.$http.get(this.apiRoot + '/arfolyam/aktualis');
	};

	ArfolyamService.prototype.getTekozForInterval = function getTekozForInterval(dates) {
		return this.$http.post(this.apiRoot + '/arfolyam/tekoz', dates);
	};

	ArfolyamService.prototype.getArfolyam = function getArfolyam(dates) {
		return this.$http.post(this.apiRoot + '/arfolyam', dates);
	};

	ArfolyamService.prototype.getTekozInitDates = function getTekozInitDates() {
		return this.$http.get(this.apiRoot + '/arfolyam/tekoz/init');
	};

	ArfolyamService.prototype.getTekozForDate = function getTekozForDate() {
		return this.$http.get(this.apiRoot + '/arfolyam/tekoz');
	};

	ArfolyamService.prototype.getSzolgaltatasForDate = function getSzolgaltatasForDate() {
		return this.$http.get(this.apiRoot + '/arfolyam/szolgaltatasi');
	};

	ArfolyamService.prototype.getSzolgaltatasiForDate = function getSzolgaltatasiForDate(date) {
		return this.$http.get(this.apiRoot + '/arfolyam/szolgaltatasi');
	};

	ArfolyamService.prototype.getGrafikonInitDates = function getGrafikonInitDates() {
		return this.$http.get(this.apiRoot + '/arfolyam/init');
	};

	ArfolyamService.prototype.getPortfolioChartAdatok = function getPortfolioChartAdatok(responseData) {

		if (responseData.portfolios.length && responseData.portfolios[0].data.length < 2) {
			return null;
		}

		var colors = ['#52ae30', '#8946ae', '#ff6600', '#84ff8c', '#2950ff', '#1bffed'];
		var reformattedDataArray = responseData.dates.map(function (date) {
			var monthForUtc = parseInt(date.substring(4, 6)) - 1; // hónapok számozását az UTC 0-val kezdi
			return Date.UTC(date.substring(0, 4), monthForUtc, date.substring(6, 8));
		});

		var graphSeries = [];
		var graphData = [];
		for (var j = 0; j < responseData.portfolios.length; j++) {
			for (var i = 0; i < reformattedDataArray.length; i++) {
				graphData.push([reformattedDataArray[i], responseData.portfolios[j].data[i]]);
			}
			var obj = {
				name: responseData.portfolios[j].name,
				data: graphData,
				color: colors[j],
				linkedTo: j
			};

			var linkedObj = {
				data: [],
				name: responseData.portfolios[j].name,
				id: j,
				color: colors[j],
				marker: {
					enabled: true,
					symbol: 'square',
					radius: 10
				}
			};

			graphSeries.push(obj);
			graphSeries.push(linkedObj);
			graphData = [];
		}

		return {
			chart: {
				type: 'line',
				marginTop: 60
			},
			plotOptions: {
				series: {
					marker: {
						enabled: false
					},
					events: {
						legendItemClick: function legendItemClick() {
							return false;
						}
					}
				}
			},
			title: {
				text: ''
			},
			yAxis: {
				title: {
					text: ''
				},
				opposite: true
			},
			xAxis: {
				type: 'datetime',
				title: {
					text: ''
				},
				labels: {
					formatter: function formatter() {
						return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).format("YYYY.MM.DD");
					}
				}
			},
			tooltip: {
				headerFormat: '<b>{series.name}</b><br>',
				pointFormat: '{moment(point.x).format("YYYY.MM.DD")}{point.y:.2f}',
				formatter: function formatter() {
					var formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.x).format('YYYY.MM.DD');
					return '<span style="font-size=10">' + formattedDate + '</span><br/>\n\t\t\t\t\t\t\t<span style="color:' + this.color + '">\u25CF</span>\n\t\t\t\t\t\t\t<span style="font-weight:bold">' + this.y + '</span>';
				}
			},
			legend: {
				align: 'left',
				verticalAlign: 'bottom',
				backgroundColor: '#FFFFFF',
				itemMarginBottom: 10
			},
			series: graphSeries
		};
	};

	return ArfolyamService;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).service('arfolyamService', ArfolyamService).name);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_container_grafikon_form_grafikon_form_pcss__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_container_grafikon_form_grafikon_form_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__grafikon_container_grafikon_form_grafikon_form_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grafikon_container_grafikon_container_grafikon_container_js__ = __webpack_require__(298);



/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grafikon_form_pug__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grafikon_form_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grafikon_form_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_date_picker__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_constants_consts__ = __webpack_require__(32);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Grafikon form megjelenítő komponens
 * @author Koppany Kiss 2017.05.22.
 */






var MODULE_NAME = 'grafikonForm';
var DATE_YEARS = [{ year: '2010' }, { year: '2011' }];

var GrafikonFormController = function () {
	GrafikonFormController.$inject = ['$scope'];

	function GrafikonFormController($scope) {
		'ngInject';

		_classCallCheck(this, GrafikonFormController);

		this.$scope = $scope;
		this.DATE_YEARS = DATE_YEARS;
	}

	GrafikonFormController.prototype.$onInit = function $onInit() {
		var _this = this;

		this.kezdoMinDate = '2008-01-01';
		this.zaroMaxDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]);
		this.isAllPortfolioSelected = false;
		this.model = {
			portfolio: {}
		};
		this.downloadDates = {};
		this.downloadPortfolios = [];
		this.selectedPortfolioForRequest = [];
		this.$scope.$watch('$ctrl.datePickerFromIsOpen', function (newValue) {
			if (newValue === false) {
				_this.focusDatePicker('start-date-button');
			}
		});
		this.$scope.$watch('$ctrl.datePickerToIsOpen', function (newValue) {
			if (newValue === false) {
				_this.focusDatePicker('end-date-button');
			}
		});
	};

	GrafikonFormController.prototype.$onChanges = function $onChanges(changeObject) {
		var _this2 = this;

		if (changeObject.initData && !changeObject.initData.isFirstChange()) {
			var restInitData = angular.copy(this.initData);
			this.model.from = new Date(restInitData.startDate);
			this.model.to = new Date(restInitData.endDate);

			this.downloadDates = {
				startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(restInitData.startDate).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]),
				endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(restInitData.endDate).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */])
			};

			this.initData.portfolios.map(function (item) {
				_this2.model.portfolio[item] = false;
			});
		}
	};

	GrafikonFormController.prototype.focusDatePicker = function focusDatePicker(id) {
		var elem = document.getElementById(id);
		if (elem) {
			elem.focus();
		}
	};

	GrafikonFormController.prototype.postForm = function postForm() {
		this.selectedPortfolioForRequest = [];
		this.hasPortfolio = false;
		// Kötelező legalább egy portfoliót választani, re-checknél modelben marad az elem csak false lesz az értéke, ezért azt is vizsgáljuk
		if (this.model.portfolio) {
			for (var portfolio in this.model.portfolio) {
				if (this.model.portfolio[portfolio]) {
					this.hasPortfolio = true;
					this.selectedPortfolioForRequest.push(portfolio);
				}
			}
		}

		if (this.form.$valid) {
			if (this.hasPortfolio) {
				var request = {
					endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.downloadDates.endDate).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]),
					portfolios: this.selectedPortfolioForRequest,
					startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.downloadDates.startDate).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */])
				};

				this.onFormSubmit({
					formModel: request
				});
			}
		}
	};

	GrafikonFormController.prototype.changeFromDate = function changeFromDate(date) {
		this.downloadDates.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]);
	};

	GrafikonFormController.prototype.changeEndDate = function changeEndDate(date) {
		this.downloadDates.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(__WEBPACK_IMPORTED_MODULE_3__common_constants_consts__["e" /* DATE_FORMAT_FROM_SERVER */]);
	};

	GrafikonFormController.prototype.changePortfolio = function changePortfolio(portfolio) {
		var index = this.downloadPortfolios.indexOf(encodeURIComponent(portfolio));
		if (index < 0) {
			this.downloadPortfolios.push(encodeURIComponent(portfolio));
		} else {
			this.downloadPortfolios.splice(index, 1);
		}
	};

	GrafikonFormController.prototype.togglePortfolio = function togglePortfolio() {
		if (this.model.portfolio) {
			var state = this.isAllPortfolioSelected;
			if (state) {
				this.downloadPortfolios = [];
				for (var portfolio in this.model.portfolio) {
					this.model.portfolio[portfolio] = state;
					this.downloadPortfolios.push(encodeURIComponent(portfolio));
				}
			} else {
				for (var _portfolio in this.model.portfolio) {
					this.model.portfolio[_portfolio] = state;
				}
				this.downloadPortfolios = [];
			}
		}
	};

	return GrafikonFormController;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_2__common_components_date_picker__["a" /* default */]]).component('grafikonForm', {
	controller: GrafikonFormController,
	template: __WEBPACK_IMPORTED_MODULE_1__grafikon_form_pug___default()(),
	bindings: {
		initData: '<',
		onFormSubmit: '&'
	}
}).name);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_megjelenito_pug__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grafikon_megjelenito_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__grafikon_megjelenito_pug__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * kapcsolat form megjelenítő komponens
 * @author Koppany Kiss 2017.05.22.
 */


var MODULE_NAME = 'grafikonMegjelenito';

var GrafikonMegjelenitoController = function () {
	function GrafikonMegjelenitoController() {
		'ngInject';

		_classCallCheck(this, GrafikonMegjelenitoController);
	}

	GrafikonMegjelenitoController.prototype.$onInit = function $onInit() {
		this.chartOptionsGiven = angular.copy(this.chartOptions);
		this.formModelGiven = angular.copy(this.formModel);
	};

	GrafikonMegjelenitoController.prototype.$onChanges = function $onChanges(changeObject) {
		if (!changeObject.chartOptions.isFirstChange()) {
			this.chartOptionsGiven = angular.copy(this.chartOptions);
		}

		if (!changeObject.formModel.isFirstChange()) {
			this.formModelGiven = angular.copy(this.formModel);
		}
	};

	return GrafikonMegjelenitoController;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).component('grafikonMegjelenito', {
	controller: GrafikonMegjelenitoController,
	template: __WEBPACK_IMPORTED_MODULE_0__grafikon_megjelenito_pug___default()(),
	bindings: {
		chartOptions: '<',
		formModel: '<'
	}
}).name);

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-grafikon\"\u003E\u003Cgrafikon-form init-data=\"$ctrl.initData\" on-form-submit=\"$ctrl.getGrafikon(formModel)\"\u003E\u003C\u002Fgrafikon-form\u003E\u003Cloader ng-show=\"$ctrl.showLoader\"\u003E\u003C\u002Floader\u003E\u003Cgrafikon-megjelenito chart-options=\"$ctrl.chartOptions\" form-model=\"$ctrl.postedFormModel\" ng-if=\"$ctrl.showGrafikon\"\u003E\u003C\u002Fgrafikon-megjelenito\u003E\u003Cdiv ng-show=\"$ctrl.notEnoughData\"\u003EKérem, adjon meg nagyobb intervallumot!\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"app-grafikon__form\" name=\"$ctrl.form\" novalidate\u003E\u003Ch3 class=\"app-grafikon__title\"\u003EÁrfolyamok idősoros lekérdezése\u003C\u002Fh3\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Clabel class=\"label label--right\" aria-hidden=\"true\" for=\"app-grafikon__start-date-year\"\u003EKezdő dátum:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"datepicker\"\u003E\u003Cdate-picker id=\"app-grafikon__start-date\" min-date=\"$ctrl.kezdoMinDate\" date-model=\"$ctrl.model.from\" on-date-change=\"$ctrl.changeFromDate(date)\" main-label=\"Kezdő dátum\"\u003E\u003C\u002Fdate-picker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Clabel class=\"label label--right\" aria-hidden=\"true\" for=\"app-grafikon__end-date-year\"\u003EZáró dátum:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"datepicker\"\u003E\u003Cdate-picker id=\"app-grafikon__end-date\" date-model=\"$ctrl.model.to\" max-date=\"$ctrl.zaroMaxDate\" on-date-change=\"$ctrl.changeEndDate(date)\" main-label=\"Záró dátum\"\u003E\u003C\u002Fdate-picker\u003E\u003C\u002Fdiv\u003E\u003Cinput-error id=\"endDateError\" form=\"$ctrl.form\" input-name=\"datePickerTo\" message-required=\"Kérem adja meg a záró dátumot!\" message-date-from-to=\"Kezdő dátum nem lehet nagyobb, mint a záró dátum!\" message-is-date-valid=\"Nem létező dátum. Kérem adja meg helyesen a záró dátumot!\" message-max-length=\"Túl hosszú a megadott záró dátum.\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cfieldset class=\"app-grafikon__checkbox-container\"\u003E\u003Clegend class=\"sr-only\"\u003EVálasszon az alábbi portfólió lehetőségek közül!\u003C\u002Flegend\u003E\u003Cdiv class=\"checkbox__item\" ng-repeat=\"(key, value) in $ctrl.model.portfolio\"\u003E\u003Cinput id=\"{{key}}\" type=\"checkbox\" ng-model=\"$ctrl.model.portfolio[key]\" value=\"key\" ng-change=\"$ctrl.changePortfolio(key)\" ng-required=\"$ctrl.model.portfolio.length &lt;= 0\"\u003E\u003Clabel class=\"checkbox\" for=\"{{ key }}\"\u003E{{key}}\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkbox__item checkbox__item--select-all\"\u003E\u003Cinput id=\"select-all\" type=\"checkbox\" ng-model=\"$ctrl.isAllPortfolioSelected\" ng-change=\"$ctrl.togglePortfolio()\"\u003E\u003Clabel class=\"checkbox\" for=\"select-all\"\u003EMind kijelölése\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"error\" ng-show=\"$ctrl.hasPortfolio == false\"\u003E\u003Cdiv class=\"error__chip\" aria-live=\"assertive\"\u003E\u003Cspan class=\"onyp-info error__icon\" aria-hidden=\"true\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003EKérem, válasszon legalább egy portfóliót!\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003Cbutton class=\"button\" type=\"submit\" ng-click=\"$ctrl.postForm()\" ng-disabled=\"!$ctrl.form.$valid || $ctrl.downloadPortfolios.length == 0 \"\u003EGrafikont kérek\u003C\u002Fbutton\u003E\u003Ca class=\"button\" ng-disabled=\"!$ctrl.form.$valid || $ctrl.downloadPortfolios.length == 0\" ng-href=\"{{($ctrl.form.$valid &amp;&amp; $ctrl.downloadPortfolios.length &gt; 0) ? ('\u002Fapi\u002Farfolyam\u002Fletoltes?portfolios=' + $ctrl.downloadPortfolios.join(',') + '&amp;startDate=' + $ctrl.downloadDates.startDate + '&amp;endDate=' + $ctrl.downloadDates.endDate) : ''}}\" role=\"button\"\u003ELetöltöm az adatokat\u003Cspan class=\"sr-only\"\u003Eexcel dokumentumként.\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-grafikon__megjelenito\"\u003E\u003Cdiv class=\"sr-only\" id=\"highcharts-information-region\" role=\"region\" aria-label=\"Grafikon információk hangosfelolvasó programok számára\"\u003E\u003Cdiv\u003EHasználja a billentyűzetet a grafikon elhagyására, és az adatok közötti navigációhoz.\u003Ch3\u003EGrafikon : Az egyes portfólióink aktuális árfolyamai {{ $ctrl.formDataGiven.kezdoDatum }} és {{ $ctrl.formDataGiven.zaroDatum }} között\u003C\u002Fh3\u003E\u003Ch4\u003EStruktúra\u003C\u002Fh4\u003E\u003Cdiv\u003EGrafikon típusa : Vonaldiagram\u003C\u002Fdiv\u003E\u003Cdiv\u003EA tgrafikon vonala {{ $ctrl.chartOptionsGiven.series.length }} adatpontot tartalmaz.\u003C\u002Fdiv\u003E\u003Cdiv\u003EAz X tengely felirata: dátum\u003C\u002Fdiv\u003E\u003Cdiv\u003EAz Y tengely felirata: portfólió értékek\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ch4\u003E\u003Ca href=\"#highcharts-data-table\" tabindex=\"-1\"\u003EMegtekintés táblázatként\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Ch4 class=\"sr-only\"\u003EVonaldiagram.\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv aria-role=\"presentation\" hc-chart options=\"$ctrl.chartOptions\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"sr-only\" aria-live=\"polite\"\u003EA grafikon adatai frissültek\u003C\u002Fspan\u003E\u003Ctable class=\"sr-only\" id=\"highcharts-data-table\"\u003E\u003Ccaption class=\"sr-only\"\u003EAz egyes portfólióink aktuális árfolyamai\u003C\u002Fcaption\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth scope=\"col\"\u003EÁRFOLYAM\u003Cbr\u003EKELTE\u003C\u002Fth\u003E\u003Cth scope=\"col\" ng-repeat=\"item in $ctrl.chartOptionsGiven.series track by $index\"\u003E{{ item.name }}\u003Cbr\u003EPORTFÓLIÓ\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Cthead\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E\u003Ctr ng-repeat=\"rows in $ctrl.chartOptionsGiven.xAxis.categories track by $index\"\u003E\u003Ctd\u003E{{ rows | date:'yyyy.MM.dd' }}\u003C\u002Ftd\u003E\u003Ctd ng-repeat=\"item in $ctrl.chartOptionsGiven.series\"\u003E{{ item.data[$parent.$index] | number:6 }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[537]);


// WEBPACK FOOTER //
// application/grafikon-container.bundle.js